import React, { useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { Buttons } from '../../constants/Buttons';

interface FullButtonProps {
  text: string;
  onClick: (setIsLoading: (isLoading: boolean) => void) => void;
  disabled?: boolean;
}

const FullButton: React.FC<FullButtonProps> = ({
  text,
  onClick,
  disabled = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Box>
      <Button
        disabled={isLoading || disabled}
        variant="contained"
        sx={{
          ...Buttons.primary,
          width: '100%',
          textTransform: 'none',
        }}
        onClick={() => onClick(setIsLoading)}
      >
        {text}
        {isLoading && (
          <CircularProgress
            color="inherit"
            sx={{ marginLeft: '10px' }}
            size={20}
          />
        )}
      </Button>
    </Box>
  );
};

export default FullButton;
